import { Fragment } from 'react';
import { Router, Switch, Route } from "react-router-dom";


import { createBrowserHistory } from "history";

//import { useDispatch } from 'react-redux';
//import Chatbot from './components/Chatbot';




import { useEffect, useState } from "react";
import { MobileNavProvider } from "./context/MobileNavContext";

import Login from "./pages/auth/Login";
import Recovery from "./pages/auth/Recovery";
import Dashboards from "./pages/dashboard/Dashboards";
import Risk from "./pages/risk/Risk";
import Gantt from "./pages/risk/Gantt";
import Departments from "./pages/organization/Departments";
import Incidents from "./pages/risk/Incidents";
import Profile from "./pages/account/Profile";
import Settings from "./pages/account/Settings";
import Help from "./pages/account/Help";
import Users from "./pages/Users";
import Units from "./pages/riskCenter/Units";
import ManageRiskCenter from "./pages/riskCenter/ManageRiskCenter";
import ManageSubRiskCenter from "./pages/riskCenter/ManageSubRiskCenter";
import AIPage from "./pages/ai/AI";
import Files from "./pages/files/Files";
import RiskLevels from "./pages/risk/RiskLevels";
import Compliance from "./pages/compliance/Compliance";
import ComplianceCards from './pages/compliance/ComplianceCards';
import BowtieAnalysis from './pages/risk/BowtieAnalysis';
import IT from "./pages/it/IT";
import WorkflowEditor from "./components/Workflow/WorkflowEditor";
import AllControls from "./pages/risk/AllControls"
import RiskPage from './components/Risk/RiskPage';
import Survey from "./pages/survey/Survey";
import Audit from './pages/audit/Audit';
import Marketplace from './pages/marketplace/Marketplace';
import Chatbot from './pages/ai/Chatbot';


const history = createBrowserHistory();

function useNormalizeTo100({ targetDPR = 1, userScale = 1 } = {}) {
  useEffect(() => {
    const apply = () => {
      const dpr = window.devicePixelRatio || 1;
      const uiScale = (targetDPR / dpr) * userScale;
      document.documentElement.style.setProperty("--ui-scale", String(uiScale));
    };
    apply();

    const onResize = () => apply();
    window.addEventListener("resize", onResize);
    document.addEventListener("visibilitychange", apply);

    return () => {
      window.removeEventListener("resize", onResize);
      document.removeEventListener("visibilitychange", apply);
    };
  }, [targetDPR, userScale]);
}

function Main() {
  const [userScale, setUserScale] = useState(() => {
    const v = localStorage.getItem("uiScale");
    return v ? Number(v) : 1;
  });
  useEffect(() => { localStorage.setItem("uiScale", String(userScale)); }, [userScale]);

  // normalize UI to “true 100%”
  useNormalizeTo100({ targetDPR: 1, userScale });

  return (
    <div className="App">
      <Fragment>
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/recovery" component={Recovery} />
          <Route exact path="/dashboards/:id?" component={Dashboards} />
          <Route exaxt path="/bowtie/:id" component={BowtieAnalysis}/>
          <Route exact path="/risk/:view_risk?" component={Risk} />
          <Route exact path="/actions" component={Gantt} />
          <Route exact path="/departments" component={Departments} />
          <Route exact path="/incidents/:risk_id" component={Incidents} />
          <Route exact path="/profile" component={Profile} />
          <Route exact path="/settings" component={Settings} />
          <Route exact path="/help" component={Help} />
          <Route exact path="/admin" component={Users} />
          <Route exact path="/risk_center" component={Units} />
          <Route exact path="/controls" component={AllControls} />
          <Route exact path="/survey" component={Survey} />
          <Route exact path="/audit" component={Audit} />
          <Route exact path="/files" component={Files} />
          <Route exact path="/risk_levels" component={RiskLevels} />
          <Route exact path="/risk_overview/:id" component={RiskPage} />
          <Route exact path="/compliance" component={Compliance} />
          <Route exact path="/standards" component={ComplianceCards}/>
          <Route exact path="/IT" component={IT}/>
          <Route exact path="/edit/:id" component={WorkflowEditor} />
          <Route exact path="/marketplace" component={Marketplace} />
          <Route exact path="/chat" component={Chatbot} />
          <Route exact path="/manage_risk_center/:id" component={ManageRiskCenter} />
          <Route exact path="/manage_sub_risk_center/:id" component={ManageSubRiskCenter} />
        </Switch>

        {/* optional: small zoom slider, can remove if boss says no */}
        {/* <div className="fixed bottom-4 right-4 bg-white/90 border rounded-lg shadow p-2 flex items-center gap-2 z-[9999]">
          <span className="text-xs text-gray-600">UI Zoom</span>
          <input type="range" min={0.9} max={1.2} step={0.05}
                 value={userScale}
                 onChange={(e) => setUserScale(Number(e.target.value))} />
        </div> */}
      </Fragment>
    </div>
  );
}

function App() {
  return (
    <Router history={history}>
      <MobileNavProvider>
        <Main />
      </MobileNavProvider>
    </Router>
  );
}

export default App;
